angular.module("vgresiduos").directive("disposalAdditionalInformation", function () {
	return {
		scope: true,
		controller: "DisposalAdditionalInformationCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalAdditionalInformation/disposalAdditionalInformation_template.html"
	};
});
